(function(){
    "use strict";
    
    angular
        .module("app")
        .component("loggedInHome", { // logged-in-home
            templateUrl: "src/app/home/loggedInHome/loggedInHome.html",
            controller: controller
        });

    function controller(session) {
        const $ctrl = this;
        $ctrl.session = session;
    }
    controller.$inject = ["sessionService"];
    
})()